import {RenovationType} from "../Models/RenovationType";
import {RenovationKeyEnum} from "../enums/renovation-key.enum";
import {returnCompaniesForRenovOptions} from "./utils";


export const RenovationTypesList: RenovationType[] = [
	{
		code: RenovationKeyEnum.COMPLETE,
		label: "Travaux rénovation",
		icon: "chiff_renov_complete",
		texte: "Une rénovation faites pour les 20 prochaines années :<br/>- Sols murs et plafonds, placards,<br/>- Plomberie et équipements des pièces d’eau,<br/>- Installations de chauffage et eau chaude,<br/>- Installation électrique,<br/>- Meubles cuisines y compris électroménager.<br/><br/>Vous pourrez ajuster si nécessaire les prestations dans notre <span class='text-nowrap'>calculateur !</span>",
		showInRefs: returnCompaniesForRenovOptions(RenovationKeyEnum.COMPLETE)
	},
	{
		code: RenovationKeyEnum.REFRESH,
		label: "Travaux rénovation légère",
		icon: "chiff_renov_legere",
		texte: "Idéale pour une remise au propre avant aménagement :<br/>Sols, murs et plafonds",
		showInRefs: returnCompaniesForRenovOptions(RenovationKeyEnum.REFRESH)
	},
	{
		code: RenovationKeyEnum.ENERGIE,
		label: "Travaux rénovation énergétique",
		icon: "chiff_renov_energie",
		texte: "Estimation des seuls Travaux énergétiques incluant les travaux d'embellissements concécutifs aux travaux pour optimiser l'étiquette de votre DPE",
		showInRefs: returnCompaniesForRenovOptions(RenovationKeyEnum.ENERGIE)
	},
	{
		code: RenovationKeyEnum.TOTALE,
		label: "Travaux rénovation + énergétique",
		icon: "chiff_renov_totale",
		texte: "La rénovation complète intégrant l'ensemble des travaux énergétiques pour optimiser l'étiquette de votre DPE",
		showInRefs: returnCompaniesForRenovOptions(RenovationKeyEnum.TOTALE)
	}
]
